(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('ProvisioningFilterController', ProvisioningFilterController);

    ProvisioningFilterController.$inject = ['$scope', '$state', '$stateParams', '$rootScope', 'OltService', 'OnuService', 'AlarmService'];

    function ProvisioningFilterController($scope, $state, $stateParams, $rootScope, OltService, OnuService, AlarmService) {

        // Variables
        var vm = this;
        vm.selected = {olt: null, onu: null};
        vm.porta = '';
        vm.placeholder = {olt: '', onu: ''};
        vm.onuName = '';
        vm.listOlts = [];
        vm.listOnus = [];
        vm.listGponPortas = [{value: ''},{value: '1'},{value: '2'},{value: '3'},{value: '4'},{value: '5'},{value: '6'},{value: '7'},{value: '8'}];

        // Method handler
        vm.changeOltItemSelected = changeOltItemSelected;
        vm.filter = filter;
        vm.clear = clear;

        // Method handler
        function changeOltItemSelected(item) {
            vm.selected.onu = null;
            getOnus(item.id || null);
        }

        function filter() {
            var oltId = vm.selected && vm.selected.olt && vm.selected.olt.id;
            //var onuId = vm.selected && vm.selected.onu && vm.selected.onu.id;
            var name = null;
            var portNumber = null;

            if (vm.porta != '') {
                portNumber = vm.porta.value;
            }
            if (vm.onuName != '') {
                name = vm.onuName;
            }
            var data = {
                oltId: oltId,
                //onuId: onuId,
                onuName: name,
                porta: portNumber
            };
           
            $scope.$emit('newDataFilter', data);
        }

        function verifyParams() {
            if ($stateParams.id && $stateParams.name && $stateParams.type) {
                angular.forEach(vm.listOlts, function (item) {
                    if (item.id == $stateParams.id) {
                        vm.selected.olt = item;
                        changeOltItemSelected(item);
                        filter();
                    }
                });
            }
        }

        function clear() {
            vm.selected.olt = vm.listOlts[0];
            vm.porta = '';
            vm.onuName = '';
            $scope.$emit('newClearFilter', {});
            //changeOltItemSelected({});            
        }

        // Method api
        function getOlts() {
            vm.placeholder.olt = 'global.common.loading';
            OltService.listOlts({}, true).then(getOltSuccess).catch(getOltError);
        }

        function getOnus(oltId) {
            vm.listOnus = [];
            vm.placeholder.onu = 'global.common.loading';
            OnuService.getAuthorizedOnuVmList({oltId: oltId}, true).then(getOnuSuccess).catch(getOnuError);
        }

        // Method response
        function getOltSuccess(data) {
            vm.listOlts = data;
            if (data.length) {
                vm.placeholder.olt = '';
                vm.listOlts.unshift({});
            } else {
                vm.placeholder.olt = 'provisioning.placeholder.noOltFound';
            }
            verifyParams();
        }

        function getOltError(response) {
            AlarmService.errorModalConstructor(response, 'getOltList');
        }

        function getOnuSuccess(data) {
            vm.listOnus = data;
            if (data.length) {
                vm.placeholder.onu = '';
                vm.listOnus.unshift({});
                vm.selected.onu = vm.listOnus[0];
            } else {
                vm.placeholder.onu = 'provisioning.placeholder.noOnuFound';
            }
        }

        function getOnuError(response) {
            AlarmService.errorModalConstructor(response, 'getOnuList');
        }

        var cancelListener = $rootScope.$on('cleanFilter', function (event, forceClean) {
            if (forceClean || (vm.selected.olt && vm.selected.olt.id) || (vm.selected.onu && vm.selected.onu.id)) {
                clear();
            }
        });
        $rootScope.$on('$destroy', cancelListener);

        // Initialize
        function initialize() {
            getOlts();

            if ($stateParams.id != null) {
                getOnus();
            }
        }
        initialize();
    }
})();
